<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: route('activities.index'),
                    },
                    {
                        name: $t('messages.create_multiple'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <h3 class="text-lg font-medium leading-6 text-gray-900">
                    {{ $t('messages.information') }}
                </h3>
                <p class="mt-1 text-sm leading-5 text-gray-500">&nbsp;</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-8">
                    <div class="sm:col-span-8">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{ $tc('messages.programmings', 1) }}
                        </label>
                        <div class="mt-1">
                            {{ session.programming_subject.programming.title }}
                        </div>
                    </div>

                    <div class="sm:col-span-2">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{ $t('messages.grade_level') }}
                        </label>
                        <div class="mt-1">
                            {{ meta.info.grade_level_names }}
                        </div>
                    </div>

                    <div class="sm:col-span-2">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{ $tc('messages.subject', 1) }}
                        </label>
                        <div class="mt-1">
                            {{ session.programming_subject.subject.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="md:grid md:grid-cols-3 md:gap-6">
            <div class="md:col-span-1">
                <h3 class="text-lg font-medium leading-6 text-gray-900">-</h3>
                <p class="mt-1 text-sm leading-5 text-gray-500">&nbsp;</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-8">
                    <div class="sm:col-span-2">
                        <label class="block text-sm font-medium leading-5 text-gray-700">
                            {{ $t('messages.trimester') }}
                        </label>
                        <div class="mt-1">
                            {{ session.programming_subject.programming.trimester }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <form :action="route('session.activities.store', session.id)" method="post" @submit.prevent="submit">
            <ActivityBatchCreateTable
                v-model="form.activities"
                :options="options"
                :defaults="defaults"
                :errors="form.errors"
            />

            <div class="w-full mt-5 flex justify-end items-center">
                <div>
                    <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
                </div>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import ActivityBatchCreateTable from '@/components/ActivityBatchCreateTable.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        PanelPage,
        ActivityBatchCreateTable,
    },
    props: ['defaults', 'session', 'options', 'meta'],
    layout: Layout,
    data() {
        return {
            form: this.$inertia.form({
                activities: [],
            }),
        };
    },
    name: 'Create',
    computed: {},
    methods: {
        submit() {
            this.form.post(route('session.activities.store', this.session.id));
        },
    },
};
</script>
